
import * as Yup from "yup";
import { buildFormData } from "../../api/helper/buildFormData";



export const getInitialValues = (objectToEdit: any | null = null): any => {
  //@ts-ignore
  return {
    id: objectToEdit?.id ?? null,
    key: objectToEdit?.key ,
    type: objectToEdit?.type ,
    value: objectToEdit?.value ,
    value_type: objectToEdit?.key === "home_main_image" || objectToEdit?.key  === "portfolio" ?  "image" : "text" ,


  };
};

export const getInitialValuesForAdd = (objectToEdit: any | null = null): any => {
  return {
    key: null ,
    type: null ,
    value: null ,
    value_type: "text",


    

  };
};

export const getValidationSchema = (editMode: boolean = false): Yup.Schema<any> => {
  // Validate input
  return Yup.object().shape({
    key: Yup.string().required('Required'),
    type: Yup.string().required('Required'),
    value: Yup.string().required('Required'),


  });
};



export const getDataToSend = (values: any): FormData => {
  const data = { ...values };


  const formData = new FormData();
  buildFormData(formData, data);
  return formData;
};

export const ChangeDataToPrint = (data: any) => {

  let new_array = data
  for (let i = 0; i < data.length; i++) {
    new_array[i]['status'] = !data[i]['deleted_at'] ? 'available' : 'unavailable'
    delete new_array[i]['deleted_at']
  }
  return new_array
}